var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UPI "
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.18182 29.6364L14.4263 3.72727C16.3705 7.51733 20.348 15.1596 20.7499 15.9052C21.1089 16.5712 21.0569 16.775 20.7499 17.1478L7.18182 29.6364Z",
    stroke: "#323232",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18182 29.6364L14.4263 3.72727C16.3705 7.51733 20.348 15.1596 20.7499 15.9052C21.1089 16.5712 21.0569 16.775 20.7499 17.1478L7.18182 29.6364Z",
    stroke: "#323232",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18182 29.6364L14.4263 3.72727C16.3705 7.51733 20.348 15.1596 20.7499 15.9052C21.1089 16.5712 21.0569 16.775 20.7499 17.1478L7.18182 29.6364Z",
    stroke: "#323232",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M2 28.7727L9.69727 2C11.7629 5.91639 15.9891 13.8134 16.4161 14.5838C16.7975 15.2721 16.7422 15.4827 16.4161 15.8679L2 28.7727Z",
    fill: "#fff",
    stroke: "#323232",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpi);
export default __webpack_public_path__ + "static/media/upi.accffe187969f07e58961228f019e1f6.svg";
export { ForwardRef as ReactComponent };